<template>
  <div class="kpi-card">
    <div v-if="title" class="kpi-card__head">
      <span class="kpi-card__title">{{ title }}</span>
    </div>

    <a-skeleton v-if="loading" active :paragraph="{ rows: 4 }" />
    <div
      v-else
      class="kpi-card__grid"
      :style="{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { Skeleton } from 'ant-design-vue';

export default {
  name: 'KpiCard',

  components: {
    'a-skeleton': Skeleton,
  },

  props: {
    title: { type: String, default: '' },
    columns: { type: Number, default: 2 },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.kpi-card {
  background: #fff;
  border: 1px solid #EFEAE4;
  border-radius: 8px;
  padding: 18px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
}

.kpi-card__head {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.kpi-card__title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #212121;
}

.kpi-card__grid {
  display: grid;
  gap: 18px 20px;
}
</style>
